import React from "react";

export const TextAvatar = ({nickname}) => {
    return (<div className="avatar">{nickname}</div>);
};

export const UserAvatar = ({nickname, url}) => {
    return (<div className="avatar avatar-img" title={nickname} style={{backgroundImage: `url(${url})`}} />);
}

export const DefaultAvatar = () => {
    return (<UserAvatar nickname="" url="/player/images/avatar.svg" />);
};

export default ({client}) => {
    if (!client) {
        return (<DefaultAvatar />);
    }

    let nickname = client.nickname || client.info?.nickname || '';
    let avatar = client.avatar || client.info?.avatar || '';

    if (avatar && avatar !== '/player/images/avatar.svg') {
        return (<UserAvatar nickname={nickname} url={avatar} />);
    }

    nickname = nickname.substr(0, 1);
    if (!nickname) {
        nickname = ((client.info?.name || '').substr(0, 1) + (client.info?.surname || '').substr(0, 1)).trim();
    }
    return (<TextAvatar nickname={nickname} />);
}
